import {useEffect, useState} from 'react';
import {IBiddersFilter} from '~/modules/Bidders/api';

const FILTER_STORAGE_KEY = 'bidders.filter';
const LEGACY_TAG_STORAGE_KEY = 'bidders.tagFilter';

const defaultFilter: IBiddersFilter = {
    active: true,
    bidderSearch: '',
    agencySearch: '',
    auctionCategory: null,
    tag: '',
    bulkActions: false,
    checkAll: false,
    refreshTags: false
};

const getInitialFilter = (): IBiddersFilter => {
    const base = {...defaultFilter};
    if (typeof window === 'undefined') {
        return base;
    }
    let stored: Partial<IBiddersFilter> = {};
    try {
        const raw = window.localStorage.getItem(FILTER_STORAGE_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === 'object') {
                stored = parsed as Partial<IBiddersFilter>;
            }
        }
    } catch {
    }
    if (!stored.tag) {
        try {
            const legacyTag = window.localStorage.getItem(LEGACY_TAG_STORAGE_KEY);
            if (legacyTag) {
                stored.tag = legacyTag;
            }
        } catch {
        }
    }
    return {
        ...base,
        ...stored,
        bulkActions: false,
        checkAll: false,
        refreshTags: false
    };
};

export const usePersistedBiddersFilter = () => {
    const [filter, setFilter] = useState<IBiddersFilter>(() => getInitialFilter());

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const payload = {
            active: filter.active,
            bidderSearch: filter.bidderSearch ?? '',
            agencySearch: filter.agencySearch ?? '',
            auctionCategory: filter.auctionCategory ?? null,
            tag: filter.tag ?? ''
        };
        try {
            window.localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(payload));
            window.localStorage.removeItem(LEGACY_TAG_STORAGE_KEY);
        } catch {
        }
    }, [filter.active, filter.bidderSearch, filter.agencySearch, filter.auctionCategory, filter.tag]);

    return [filter, setFilter] as const;
};
